module.exports = __webpack_public_path__ + "static/Build@2x-bb7362f0e2c6e622d2d237bab089647c.png";